import { render, staticRenderFns } from "./ChannelIcon.vue?vue&type=template&id=a6d6a1cc&scoped=true"
import script from "./ChannelIcon.vue?vue&type=script&lang=js"
export * from "./ChannelIcon.vue?vue&type=script&lang=js"
import style0 from "./ChannelIcon.vue?vue&type=style&index=0&id=a6d6a1cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d6a1cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6d6a1cc')) {
      api.createRecord('a6d6a1cc', component.options)
    } else {
      api.reload('a6d6a1cc', component.options)
    }
    module.hot.accept("./ChannelIcon.vue?vue&type=template&id=a6d6a1cc&scoped=true", function () {
      api.rerender('a6d6a1cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/Tenants/ChannelIcon.vue"
export default component.exports